import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import BodyRow from './BodyRow';
import Collapse from '../../Collapse';
import { useCss } from '../../system';
import { useCollapsibleRowsStore, useSubRowOpen } from '../hooks';
import { getCell, getRowLinkProps } from '../utils';

var BodySubRowsCollapse = function BodySubRowsCollapse(_ref) {
  var children = _ref.children,
      lazy = _ref.lazy,
      rowIndex = _ref.rowIndex;
  var instant = useCollapsibleRowsStore(function (state) {
    return state.instant;
  });
  var isSubRowOpen = useSubRowOpen(rowIndex);
  return /*#__PURE__*/React.createElement(Collapse, {
    lazy: lazy,
    instant: instant,
    open: isSubRowOpen,
    role: "row",
    style: {
      minWidth: 'min-content'
    }
  }, children);
};

var BodySubRows = function BodySubRows(_ref2) {
  var columns = _ref2.columns,
      columnWidths = _ref2.columnWidths,
      data = _ref2.data,
      getColumnRef = _ref2.getColumnRef,
      getRowLink = _ref2.getRowLink,
      getVariant = _ref2.getVariant,
      keyboardShortcuts = _ref2.keyboardShortcuts,
      onRowClick = _ref2.onRowClick,
      parentRowIndex = _ref2.parentRowIndex;
  var css = useCss();
  return /*#__PURE__*/React.createElement(BodySubRowsCollapse, {
    lazy: columns.some(function (column) {
      return column.includeSubCellWidth;
    }) === false,
    rowIndex: parentRowIndex
  }, data.map(function (rowData, rowIndex) {
    var rowVariantClassName = getVariant('bodySubRow', {
      rowData: rowData,
      rowIndex: rowIndex,
      parentRowIndex: parentRowIndex,
      isLink: Boolean(getRowLink) || Boolean(onRowClick),
      firstRow: rowIndex === 0,
      lastRow: rowIndex === Math.max(0, data.length - 1),
      evenRow: rowIndex % 2 === 0,
      oddRow: Math.abs(rowIndex % 2) === 1
    });
    return /*#__PURE__*/React.createElement(BodyRow, _extends({
      key: rowIndex,
      rowData: rowData,
      rowIndex: rowIndex,
      keyboardShortcuts: keyboardShortcuts,
      onRowClick: onRowClick,
      className: "uikit-reset " + css(rowVariantClassName)
    }, getRowLinkProps({
      getRowLink: getRowLink,
      data: rowData,
      isSubRow: true
    })), columns.map(function (column, columnIndex) {
      var cellVariantClassName = getVariant('bodySubCell', {
        rowData: rowData,
        rowIndex: rowIndex,
        columnIndex: columnIndex,
        columnWidth: columnWidths.current[columnIndex],
        firstRow: rowIndex === 0,
        lastRow: rowIndex === Math.max(0, data.length - 1),
        firstCell: columnIndex === 0,
        lastCell: columnIndex === Math.max(0, columns.length - 1)
      });
      return /*#__PURE__*/React.createElement("div", {
        key: columnIndex,
        ref: getColumnRef(columnIndex + "." + (parentRowIndex + 1) + "." + rowIndex),
        className: "uikit-reset " + css([].concat(cellVariantClassName, [column.css]))
      }, getCell(column.subCell !== undefined ? column.subCell : column.cell, {
        columnIndex: columnIndex,
        rowData: rowData,
        rowIndex: rowIndex
      }));
    }));
  }));
};

export default BodySubRows;